import { render, staticRenderFns } from "./taskContentAudit.vue?vue&type=template&id=3f45d90a&scoped=true"
import script from "./taskContentAudit.vue?vue&type=script&lang=js"
export * from "./taskContentAudit.vue?vue&type=script&lang=js"
import style0 from "./taskContentAudit.vue?vue&type=style&index=0&id=3f45d90a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f45d90a",
  null
  
)

export default component.exports